<template>
    <div class="pcr-recall-settings">
        <h1>Réglage des alertes</h1>

        <el-input placeholder="Recherche" v-model="filterText" class="table-search"></el-input>
        <el-table ref="table" :data="searchFilteredEstablishments" stripe border :default-sort="{prop: 'EstablishmentId', order: 'ascending'}" style="width: 100%" highlight-current-row>
            <el-table-column prop="EstablishmentId" label="Id" sortable width="80px"></el-table-column>
            <el-table-column prop="EstablishmentName" label="Nom" sortable></el-table-column>
            <el-table-column label="Alerte" width="84px">
                <template slot-scope="scope">
                    <el-switch
                        :disabled="scope.row.IsManaging || scope.row.IsPartner"
                        v-model="scope.row.AlertActivated"
                        @change="setAlertActivation(scope.row)"
                        on-color="#13ce66"
                        off-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Vue from 'vue';
import ZoneList from '../admin/cross-components/mixins/zone-list.vue';
export default Vue.component('pcr-client-recall-settings', {
    mixins: [ZoneList],
    data() {
        return {
            user: {}
        }
    },
    created() {
        this.$http.get('/api/user').then((response) => {
            this.user = response.data;
        });
    },
    methods: {
        refresh() {
            if(!this.user.UserId) return;

            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get(`/api/user/${this.user.UserId}/establishments`).then((response) => {
                    this.establishments = response.data;
                    
                    this.refreshing = false;
                });
            }
        },
        setAlertActivation(row) {
            this.$http.post(`/api/user/${this.user.UserId}/establishment/alert`, { establishmentId: row.EstablishmentId, activated: row.AlertActivated }).then((response) => {
                
            }, this.$defaultSwalApiResponse);
        }
    },
    watch: {
        user() {
            this.refresh();
        }
    }
});
</script>

<style>
.el-dialog__body {
    padding-top: 8px;
}

.el-dialog__header {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/client/pcr-client-recall-settings.vue